export enum UserPermissionCodeEnum {
  //ADMIN AREA
  VIEW_PROPERTY_LIST = 'VIEW_PROPERTY_LIST',
  CALL_ADMIN_REQUEST = 'CALL_ADMIN_REQUEST',
  VIEW_ADMIN_AREA = 'VIEW_ADMIN_AREA',

  //DICTIONARIES - ADMIN AREA
  VIEW_COUNTRY_LIST = 'VIEW_COUNTRY_LIST',
  CREATE_COUNTRY = 'CREATE_COUNTRY',
  EDIT_COUNTRY = 'EDIT_COUNTRY',
  DELETE_COUNTRY = 'DELETE_COUNTRY',
  VIEW_AIRPORT_LIST = 'VIEW_AIRPORT_LIST',
  CREATE_AIRPORT = 'CREATE_AIRPORT',
  EDIT_AIRPORT = 'EDIT_AIRPORT',
  DELETE_AIRPORT = 'DELETE_AIRPORT',
  VIEW_AIRCRAFT_TYPE_LIST = 'VIEW_AIRCRAFT_TYPE_LIST',
  CREATE_AIRCRAFT_TYPE = 'CREATE_AIRCRAFT_TYPE',
  EDIT_AIRCRAFT_TYPE = 'EDIT_AIRCRAFT_TYPE',
  DELETE_AIRCRAFT_TYPE = 'DELETE_AIRCRAFT_TYPE',

  //FLIGHT_SCHEDULES
  VIEW_FLIGHT_SCHEDULE_LIST = 'VIEW_FLIGHT_SCHEDULE_LIST',
  CREATE_FLIGHT_SCHEDULE = 'CREATE_FLIGHT_SCHEDULE',
  EDIT_FLIGHT_SCHEDULE = 'EDIT_FLIGHT_SCHEDULE',
  DELETE_FLIGHT_SCHEDULE = 'DELETE_FLIGHT_SCHEDULE',
  DOWNLOAD_FLIGHT_SCHEDULE = 'DOWNLOAD_FLIGHT_SCHEDULE',
  UPLOAD_FLIGHT_SCHEDULE = 'UPLOAD_FLIGHT_SCHEDULE',

  //MODELS
  VIEW_MODEL_LIST = 'VIEW_MODEL_LIST',
  CREATE_MODEL = 'CREATE_MODEL',
  DELETE_MODEL = 'DELETE_MODEL',
  EDIT_MODEL = 'EDIT_MODEL',

  //PROFILES
  VIEW_PROFILE_LIST = 'VIEW_PROFILE_LIST',
  CREATE_PROFILE = 'CREATE_PROFILE',
  EDIT_PROFILE = 'EDIT_PROFILE',
  DELETE_PROFILE = 'DELETE_PROFILE',
  VIEW_PROFILE = 'VIEW_PROFILE',

  // LINES OF FLYING
  VIEW_LINES_OF_FLYING = 'VIEW_LINES_OF_FLYING',
  EDIT_LINES_OF_FLYING = 'EDIT_LINES_OF_FLYING',

  // FLEET INFORMATION
  VIEW_FLEET_INFORMATION = 'VIEW_FLEET_INFORMATION',
  CREATE_FLEET_INFORMATION = 'CREATE_FLEET_INFORMATION',
  EDIT_FLEET_INFORMATION = 'EDIT_FLEET_INFORMATION',
  DELETE_FLEET_INFORMATION = 'DELETE_FLEET_INFORMATION',

  //USERS
  CREATE_USER = 'CREATE_USER',
  EDIT_USER = 'EDIT_USER',
  VIEW_USER = 'VIEW_USER',
  DELETE_USER = 'DELETE_USER',
  UNLOCK_USER = 'UNLOCK_USER',

  VIEW_AIRCRAFT_DAILY_PROGRAMME = 'VIEW_AIRCRAFT_DAILY_PROGRAMME',
  CREATE_AIRCRAFT_DAILY_PROGRAMME = 'CREATE_AIRCRAFT_DAILY_PROGRAMME',
  EDIT_AIRCRAFT_DAILY_PROGRAMME = 'EDIT_AIRCRAFT_DAILY_PROGRAMME',
  DELETE_AIRCRAFT_DAILY_PROGRAMME = 'DELETE_AIRCRAFT_DAILY_PROGRAMME',
  DOWNLOAD_AIRCRAFT_DAILY_PROGRAMME = 'DOWNLOAD_AIRCRAFT_DAILY_PROGRAMME',
  UPLOAD_AIRCRAFT_DAILY_PROGRAMME = 'UPLOAD_AIRCRAFT_DAILY_PROGRAMME',
  VIEW_AIRCRAFT_DAILY_PROGRAMME_LIST = 'VIEW_AIRCRAFT_DAILY_PROGRAMME_LIST',

  // RUN CONFIGURATION
  VIEW_RUN_CONFIGURATION = 'VIEW_RUN_CONFIGURATION',
  EDIT_RUN_CONFIGURATION = 'EDIT_RUN_CONFIGURATION',

  //OPERATIONAL
  VIEW_OPERATIONAL_LIST = 'VIEW_OPERATIONAL_LIST',
  EDIT_OPERATIONAL = 'EDIT_OPERATIONAL',
}
